export default "__VITE_ASSET__B5qNc8oY__"